import { render, staticRenderFns } from "./mustreadList.vue?vue&type=template&id=2ea7a1a3"
import script from "./mustreadList.vue?vue&type=script&lang=ts"
export * from "./mustreadList.vue?vue&type=script&lang=ts"
import style0 from "./mustreadList.vue?vue&type=style&index=0&id=2ea7a1a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports